import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Image, Space, Typography, Breadcrumb, Divider, Grid } from 'antd';
import Pict from '../../assets/img/group.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function About({ content }) {
  const { xs, lg } = useBreakpoint();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pageContent = content || {};
  const aimsScope = pageContent.aimsScope || {};
  const scientificCommittees = pageContent.scientificCommittees || {};
  const organizingCommittee = pageContent.organizingCommittee || {};

  const aimsTitle = aimsScope.title || 'Aims and Scope';
  const aimsParagraphs = Array.isArray(aimsScope.paragraphs)
    ? aimsScope.paragraphs
    : (aimsScope.description ? [aimsScope.description] : []);
  const aimsImageSrc = aimsScope.imageSrc || Pict;
  const aimsImageAlt = aimsScope.imageAlt || aimsTitle;

  const scientificTitle = scientificCommittees.title || 'Scientific Committees';
  const scientificItems = Array.isArray(scientificCommittees.items)
    ? scientificCommittees.items
    : [];

  const organizingTitle = organizingCommittee.title || 'Organizing Committee';
  const organizingGroups = Array.isArray(organizingCommittee.groups)
    ? organizingCommittee.groups
    : [];

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>About</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col xs={24} md={12} style={{ paddingBottom: 16 }}>
          <Image
            width={'100%'}
            src={aimsImageSrc}
            alt={aimsImageAlt}
            preview={false}
            style={{ objectFit: 'cover' }}
          />
        </Col>
        <Col xs={24} md={12}>
          <Space direction="vertical" size={xs ? 8 : 16}>
            <Text style={{ fontSize: 28, fontWeight: 'bold' }}>{aimsTitle}</Text>
            <Space direction="vertical" size={12}>
              {aimsParagraphs.map((text, index) => (
                <Text key={index} style={{ fontSize: 15 }}>{text}</Text>
              ))}
            </Space>
          </Space>
        </Col>

        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>

        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Space direction="vertical" size={xs ? 8 : 16}>
            <Text style={{ fontSize: 28, fontWeight: 'bold' }}>{scientificTitle}</Text>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {scientificItems.map((text, index) => (
                <li key={index}>
                  <Text style={{ fontSize: 15 }}>{text}</Text>
                </li>
              ))}
            </ul>
          </Space>
        </Col>

        <Col span={24} style={{ marginTop: xs ? 0 : 16 }}>
          <Divider />
        </Col>

        <Col span={24} style={{ marginTop: xs ? 0 : 16, marginBottom: xs ? 0 : 32 }}>
          <Row style={{ textAlign: 'center' }}>
            <Col span={24}>
              <Text style={{ fontSize: 28, fontWeight: 'bold' }}>{organizingTitle}</Text>
            </Col>
          </Row>
          <Row gutter={[0, 16]} style={{ marginTop: 32 }}>
            {organizingGroups.map((group, groupIndex) => (
              <React.Fragment key={`${group.label || 'group'}-${groupIndex}`}>
                <Col xs={24} lg={8}>
                  <Text style={{ fontSize: 18, fontWeight: 500 }}>{group.label}</Text>
                </Col>
                <Col xs={24} lg={16}>
                  <Space align="start" size={16}>
                    {lg ? <Text style={{ fontSize: 16 }}>:</Text> : null}
                    <Space direction="vertical" size={4}>
                      {(group.members || []).map((member, memberIndex) => (
                        <Text key={`${groupIndex}-${memberIndex}`} style={{ fontSize: 16 }}>{member}</Text>
                      ))}
                    </Space>
                  </Space>
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default About;